export default __webpack_public_path__ + "./image/b2d7d8fc6e9a322b976a6e9f88547ac1.png";